import axios from 'axios';

import { apiGatewayUrl, coreServiceUrl, simpleProjectServiceUrl } from '../config/environment';
import { FAKE_USER_ID_KEY } from '../constants';
import { ID_TOKEN } from '../providers/AppContext/AppContext';

const ourServices = [coreServiceUrl, simpleProjectServiceUrl, apiGatewayUrl];
const isUrlFromOurService = (url: string | undefined): boolean => {
  if (!url) {
    return false;
  }
  return ourServices.some((serviceUrl) => serviceUrl && url.startsWith(serviceUrl));
};

axios.defaults.timeout = 30000;

let currentLocale = '';
const ACCEPT_LANGUAGE = 'Accept-Language';
export const setCurrentLocale = (locale: string) => {
  currentLocale = locale;
};

export const FAKE_USER_HEADER_NAME = 'WSC-Anonymous-ID';

export interface BackendHttpError {
  code: number;
  message: string;
  data?: any;
}

axios.interceptors.request.use(
  (config) => {
    const fakeUserId = localStorage.getItem(FAKE_USER_ID_KEY);
    if (fakeUserId && isUrlFromOurService(config.url)) {
      config.headers = { ...config.headers, [FAKE_USER_HEADER_NAME]: fakeUserId };
    }
    if (currentLocale) {
      config.headers = { ...config.headers, [ACCEPT_LANGUAGE]: currentLocale };
    }
    const idToken = localStorage.getItem(ID_TOKEN);
    if (idToken) {
      config.headers = { Authorization: `Bearer ${idToken}`, ...config.headers };
    }
    return config;
  },
  (error) => {
    console.error(error);
    return error;
  },
);

export const setupAuthorizationTokenHandler = (
  setToken: (token: string) => void,
  removeToken: () => void,
) =>
  axios.interceptors.response.use(
    (response) => {
      if (response.headers) {
        const newToken = response.headers['x-new-token'];
        newToken && setToken(newToken);
      }
      return response;
    }, // 2XX responses
    (error) => {
      // if token is expired and refreshing it failed, clearing the token and logging out the user
      if (
        error.response &&
        error.response.status === 401 &&
        isUrlFromOurService(error.request.responseURL)
      ) {
        removeToken();
      }

      // We don't reject the promise here. Hence, when you retrieve a response from Axios you also need to expect an error.
      // eg.:
      // const ret: AxiosResponse<MyData> | AxiosError<BackendHttpError> axios.get(backend.com);
      return error;
    },
  );
